module.exports = __webpack_public_path__ + "static/AW_men-38c9c727c896c253fbda08fcfe65a77d.jpg";